/*
 * @Author: WangChao
 * @Date: 2025-12-18 21:05:03
 * @LastEditors: WangChao
 * @LastEditTime: 2026-02-27 11:47:41
 * @FilePath: \travel_ai\src\store\index.js
 * @Description:
 */
import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import chat from "./modules/chat";
import train from "./modules/train";
import zhida from "./applications/zhida/";
import fsscRobot from "./applications/fsscRobot/";
import mix from "./modules/mix";
import flight from "./modules/flight";
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    chat,
    zhida,
    fsscRobot,
    train,
    mix,
    flight
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
